// Native details handles activation; add Escape dismissal for header disclosures.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || event.defaultPrevented || !(event.target instanceof Element)) return;
  const disclosure = event.target.closest('details[open]');
  if (!disclosure || !disclosure.matches('.site-header .country-menu, .site-header .site-navigation details')) return;
  const summary = disclosure.querySelector(':scope > summary');
  if (!summary) return;
  event.preventDefault();
  disclosure.open = false;
  summary.focus();
});
